var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvatarLouise(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{opacity:0.32;}.cls-3{clip-path:url(#clip-path);}.cls-4{fill:#4e4a59;}.cls-5{fill:url(#D\xE9grad\xE9_sans_nom_145);}.cls-6{clip-path:url(#clip-path-2);}.cls-7{fill:#ff8d73;}.cls-8{fill:url(#D\xE9grad\xE9_sans_nom_49);}.cls-9{fill:#ffcb27;}.cls-10{fill:url(#D\xE9grad\xE9_sans_nom_153);}.cls-11{fill:url(#D\xE9grad\xE9_sans_nom_124);}.cls-12{fill:url(#D\xE9grad\xE9_sans_nom_124-2);}.cls-13{fill:url(#D\xE9grad\xE9_sans_nom_56);}.cls-14{fill:url(#D\xE9grad\xE9_sans_nom_86);}.cls-15{fill:url(#D\xE9grad\xE9_sans_nom_145-2);}.cls-16{opacity:0.49;fill:url(#D\xE9grad\xE9_sans_nom_145-3);}.cls-17{fill:#2d3047;}.cls-18{fill:#ff715b;opacity:0.46;}.cls-19{fill:url(#D\xE9grad\xE9_sans_nom_129);}.cls-20{fill:url(#D\xE9grad\xE9_sans_nom_120);}.cls-21{fill:#3d52d5;}.cls-22{clip-path:url(#clip-path-3);}.cls-23{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "fond",
    className: "cls-1",
    cx: 100,
    cy: 100,
    r: 100
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_145",
    x1: 233.74348,
    y1: 127.59845,
    x2: 234.99358,
    y2: 127.59845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00002,
    stopColor: "#ffbbae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38904,
    stopColor: "#ffc1b5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97047,
    stopColor: "#ffd2ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffd3cb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "cou",
    className: "cls-1",
    d: "M90.42316,93.98664c-2.63808.991-9.19094,3.45266-10.69042,8.90868-.36746,1.33707.54624,2.90011,0,5.79065-.426,2.25436-1.07036,2.743-.89087,4.00891.34082,2.40378,3.01033,3.08465,4.89978,4.89977,3.84519,3.694,3.97906,11.69766,1.3363,16.48107-3.18443,5.7639-10.64192,3.8236-12.47216,8.46326-1.89179,4.7957,3.97862,12.18528,9.35412,16.03563,12.95066,9.27626,29.81419,2.87053,33.853,1.3363,4.28257-1.62677,8.00036-3.85851,10.69042-7.57238.58007-.80082,4.74057-6.54482,2.67261-10.245-.87255-1.56119-2.49644-2.11886-4.00891-2.6726-11.73332-4.29579-12.79612-4.98743-14.2539-6.23608-3.93534-3.37089-3.98352-9.328-4.00891-12.47217-.10951-13.54844,10.98263-18.89191,8.46325-24.49888C112.82554,90.5566,99.15655,90.70591,90.42316,93.98664Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_49",
    x1: 48.57512,
    y1: 77.92703,
    x2: 159.05895,
    y2: 77.92703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3654,
    stopColor: "#ea5444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.374,
    stopColor: "#e24d3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39599,
    stopColor: "#d23f2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42127,
    stopColor: "#c93727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45691,
    stopColor: "#c63424"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_153",
    x1: 137.08842,
    y1: 80.21944,
    x2: 62.94385,
    y2: 80.21944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00002,
    stopColor: "#ffb38b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16954,
    stopColor: "#ffb792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42342,
    stopColor: "#ffc1a7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72887,
    stopColor: "#ffd2c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75242,
    stopColor: "#ffd3cb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_124",
    x1: 101.43864,
    y1: 74.71154,
    x2: 104.95447,
    y2: 68.62194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.36023,
    stopColor: "#c84428"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7402f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_124-2",
    x1: -1032.45123,
    y1: 529.47694,
    x2: -1029.46356,
    y2: 524.30214,
    gradientTransform: "matrix(0.67701, -0.32477, 0.2531, 0.5276, 638.41809, -550.97612)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_124"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_56",
    x1: 47.22133,
    y1: 65.12973,
    x2: 153.9993,
    y2: 65.12973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00044,
    stopColor: "#ff715b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23341,
    stopColor: "#ff705a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34154,
    stopColor: "#fa6952"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.50993,
    stopColor: "#ee573c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71653,
    stopColor: "#d93918"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76309,
    stopColor: "#d4310f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_86",
    x1: 73.00703,
    y1: 86.56382,
    x2: 77.57382,
    y2: 84.81079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff715b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01945,
    stopColor: "#ff745d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1695,
    stopColor: "#ff8469"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33632,
    stopColor: "#ff8e70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55173,
    stopColor: "#ff9172"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_145-2",
    x1: 122.23965,
    y1: 90.67089,
    x2: 122.49263,
    y2: 90.67089,
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_145"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_145-3",
    x1: 1488.09881,
    y1: 18.6621,
    x2: 1488.31775,
    y2: 18.6621,
    gradientTransform: "matrix(0.66319, 0.59247, -0.77214, 0.8643, -891.07419, -801.6106)",
    xlinkHref: "#D\\xE9grad\\xE9_sans_nom_145"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_129",
    x1: 70.30908,
    y1: 101.19425,
    x2: 90.50846,
    y2: 101.19425,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.50803,
    stopColor: "#ff715b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54867,
    stopColor: "#ff765f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74871,
    stopColor: "#ff8a6d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88437,
    stopColor: "#ff9172"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "D\\xE9grad\\xE9_sans_nom_120",
    x1: 75.86068,
    y1: 104.89425,
    x2: 77.55045,
    y2: 101.96749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.35982,
    stopColor: "#ff8d64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83815,
    stopColor: "#fac2b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8d4cd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M84.18708,133.63029A13.84793,13.84793,0,0,0,90.8686,142.539c5.2096,2.732,10.373.66271,12.02672,0a17.68138,17.68138,0,0,0,9.35412-9.35412c1.91441.81561,4.825,1.97781,8.46325,3.118,6.74845,2.115,8.18829,1.70659,12.02673,3.56347,2.20977,1.069,6.82767,3.303,9.35412,8.01782a16.67512,16.67512,0,0,1,1.78174,8.46325c-.29776,19.7208,4.68793,26.343,1.3363,34.29844C137.65877,208.5732,97.306,210.63159,72.16036,200c-5.06225-2.14028-18.4777-7.81239-20.93542-18.70824-.45435-2.01424-.12859-4.76341.44544-10.245a82.37669,82.37669,0,0,1,4.89978-21.38085c2.5545-6.5509,3.83175-9.82641,6.68151-11.58129,2.4929-1.5352,4.37458-1.27921,14.2539-3.118C80.3619,134.43492,82.68744,133.95142,84.18708,133.63029Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "MinDef_ILLU_vectorisation_v3 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Louise"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Louise-2",
    "data-name": "Louise"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "fond-2",
    "data-name": "fond",
    className: "cls-4",
    cx: 100,
    cy: 100,
    r: 100
  }), /*#__PURE__*/React.createElement("path", {
    id: "cou-2",
    "data-name": "cou",
    className: "cls-5",
    d: "M90.42316,93.98664c-2.63808.991-9.19094,3.45266-10.69042,8.90868-.36746,1.33707.54624,2.90011,0,5.79065-.426,2.25436-1.07036,2.743-.89087,4.00891.34082,2.40378,3.01033,3.08465,4.89978,4.89977,3.84519,3.694,3.97906,11.69766,1.3363,16.48107-3.18443,5.7639-10.64192,3.8236-12.47216,8.46326-1.89179,4.7957,3.97862,12.18528,9.35412,16.03563,12.95066,9.27626,29.81419,2.87053,33.853,1.3363,4.28257-1.62677,8.00036-3.85851,10.69042-7.57238.58007-.80082,4.74057-6.54482,2.67261-10.245-.87255-1.56119-2.49644-2.11886-4.00891-2.6726-11.73332-4.29579-12.79612-4.98743-14.2539-6.23608-3.93534-3.37089-3.98352-9.328-4.00891-12.47217-.10951-13.54844,10.98263-18.89191,8.46325-24.49888C112.82554,90.5566,99.15655,90.70591,90.42316,93.98664Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M113.41961,110.02227c1.02006,6.83594-19.416,14.56981-20.93542,15.14477-5.9791,2.26273-10.94875,4.14343-14.25389,1.78174-5.04311-3.60361-4.47713-15.84566,1.3363-21.82629C89.16067,95.25247,112.38862,103.11315,113.41961,110.02227Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Cheveux_arri\\xE8re",
    "data-name": "Cheveux arri\\xE8re",
    className: "cls-8",
    d: "M148.85411,86.51366a14.62028,14.62028,0,0,0-2.22717,2.67261c-2.52863,4.03848.47762,10.97371,0,16.03563-.73411,7.78-9.259,16.9898-18.26281,16.48107-8.808-.49774-16.61238-10.20921-15.14477-16.03563.73547-2.9198,3.30444-2.899,4.89978-5.79065,4.46614-8.09525-4.93463-27.71295-18.70824-31.62584-11.41246-3.24212-22.72253,5.1797-26.28062.44544-2.10119-2.79582.36023-7.87025-1.33631-8.46325-2.05018-.71666-4.21074,5.42633-9.79955,6.68151a11.63548,11.63548,0,0,1-10.245-3.118C46.318,58.28861,48.28117,46.05526,54.422,39.74306c8.888-9.13608,25.44353-4.75427,31.62583-3.118,10.1935,2.69794,9.05566,5.50822,20.49,9.79955,17.28945,6.48871,23.76663,1.5177,39.19822,9.35412,11.06843,5.62068,12.5721,10.63377,12.91759,12.02673,1.49274,6.01815-1.32836,14.22628-5.34521,16.03563A14.18383,14.18383,0,0,0,148.85411,86.51366Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M74.48315,88.49691a8.35637,8.35637,0,0,1-8.14489,12.88086,8.45041,8.45041,0,0,1-6.922-10.542,8.37451,8.37451,0,0,1,15.06689-2.33886Zm0,0a6.90916,6.90916,0,0,0-4.83508-3.0503,6.76151,6.76151,0,0,0-7.5896,5.938,6.812,6.812,0,0,0,13.2992,2.7627A6.9173,6.9173,0,0,0,74.48315,88.49691Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Visage",
    className: "cls-10",
    d: "M92.72939,44.1974c-12.18268-2.14365-16.7051-.96688-19.5903,1.60839-4.31624,3.85264-6.68108,12.364-6.23608,19.15368.10265,1.56663.15094,2.27741.15208,2.97362a11.45418,11.45418,0,0,1-.15208,3.26246c-.41635,2.1467-1.27492,3.16828-2.236,5.51856a36.21644,36.21644,0,0,0-1.33631,4.45434c-1.38018,5.55194,1.19711,11.0171,3.56348,22.71715,1.18019,5.83512,1.14925,7.10346,2.6726,8.90868,3.061,3.62742,8.04675,4.20129,10.245,4.45435,3.00163.34549,3.82627-.16073,11.13586-1.33631.00005,0,17.36726-2.906,20.47578-6.15419.18515-.19346.33375-.3704.45963-.52732.63417-.79049.74352-1.13621,1.79055-2.40052,2.54743-3.07617,4.63448-4.1567,8.45477-7.53725,2.85209-2.52384,3.43689-3.01723,4.01739-3.5986,6.88221-6.89206,13.70944-21.06722,9.79955-32.07127C131.46488,51.01344,114.84706,48.0893,92.72939,44.1974Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Sourcil"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M99.37678,67.71456c1.92877.06416,6.81734.22674,9.35412,4.00891a9.31663,9.31663,0,0,1,1.3363,6.23608A2.52288,2.52288,0,0,1,107.84,78.405c-.941-.46979-.70991-1.96128-1.3363-3.56347-.80311-2.05426-2.56043-3.12576-4.00891-4.00891-3.95149-2.40933-8.00634-1.74378-8.01782-2.22717C94.46836,68.23971,96.78394,67.62832,99.37678,67.71456Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M70.23625,60.92264c.51876-.219,4.57475-1.871,7.68567-.21782A5.07411,5.07411,0,0,1,80.06675,62.856a1.47778,1.47778,0,0,1-.79195.669c-.63116.16254-1.18133-.46362-1.46838-.74106-1.6-1.54649-4.6404-1.553-5.1971-1.55419-2.913-.00626-5.34608,1.95318-5.46477,1.75427C67.05527,62.8344,68.41109,61.69325,70.23625,60.92264Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M118.27332,99.11068a8.357,8.357,0,0,1-5.95948,14.02685,8.45108,8.45108,0,0,1-8.53259-9.28711,8.37486,8.37486,0,0,1,14.49207-4.73974Zm0,0a6.90952,6.90952,0,0,0-5.26392-2.23,6.81678,6.81678,0,0,0-4.745,11.418,6.79485,6.79485,0,0,0,11.78382-3.75245A6.9173,6.9173,0,0,0,118.27332,99.11068Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Cheveux_devant",
    "data-name": "Cheveux devant",
    className: "cls-13",
    d: "M111.43763,44.64283c-7.54-2.92578-12.91367-9.49691-14.25389-11.13586-3.99412-4.88434-4.568-7.9716-8.90869-10.245-1.46011-.76472-5.67711-2.65782-10.245-1.3363-5.49593,1.59-9.56188,7.273-10.245,14.25389a36.35723,36.35723,0,0,0-4.45434-2.22717c-2.63737-1.1-4.26131-1.77728-5.79065-1.78173-4.091-.01186-7.88672,4.78994-9.35412,8.90868-2.30851,6.47957-.27774,15.26276,4.00891,16.48107,2.45109.69664,5.68848-1.06628,7.127-3.56347,1.81039-3.14284.56267-7.08661,0-7.127-.41183-.02947-.38181,2.03784-1.78174,2.6726a2.67931,2.67931,0,0,1-3.118-.89087c-.89233-1.38784.28194-3.77792,1.78174-4.45434,2.14507-.96753,5.59066,1.28421,7.127,4.00891,1.42635,2.52971.26421,3.79533,1.3363,8.46325.73161,3.18547,1.36235,5.93169,3.56348,7.127,2.79266,1.5165,6.74616-.20619,8.90868-2.22717a10.84126,10.84126,0,0,0,3.118-6.23608c.73884-4.54-1.67032-6.28719-.44543-8.46325,1.66483-2.95764,7.64562-2.44848,10.245-2.22717a20.05306,20.05306,0,0,1,10.245,4.45434c.68615.58768,1.48278,1.40775,1.3363,2.22717-.1622.90751-1.34027,1.02615-1.78174,1.78174-.79837,1.36642,1.04084,4.4252,4.00891,7.127,6.03522,5.49365,10.38163,3.06562,15.5902,8.01781a18.966,18.966,0,0,1,4.82072,7.91843A21.50708,21.50708,0,0,1,124.7216,88.196c-.19525.83215-2.121,8.763-5.34521,8.90869a2.79194,2.79194,0,0,1-2.6726-1.78174,3.08238,3.08238,0,0,1,.89086-2.67261c-.21167-.1716-3.12478-2.45848-6.23608-1.3363-2.57853.93-3.71849,3.63351-3.92984,5.44461-.6202,5.31476,5.71968,11.826,12.47216,12.02673,5.25261.15616,8.95218-3.58947,9.35412-4.00891,4.434-4.627,1.82284-9.01363,5.34521-14.2539,4.20808-6.26044,10.21709-3.395,15.14476-8.90869,6.07677-6.7995,5.65433-20.90964-1.3363-28.50779-4.51992-4.91272-10.803-6.0287-16.9265-7.127C120.91981,44.08484,118.76555,47.48628,111.43763,44.64283Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Nez",
    className: "cls-14",
    d: "M72.68486,83.841c-.36152.14628-.26851,1.7685.5399,3.02744a2.8898,2.8898,0,0,0,1.68727,1.4269c1.65486.36976,3.43409-1.52965,3.20658-2.065-.19052-.44834-1.65192.38174-3.272-.409C73.39551,85.11315,73.03534,83.69913,72.68486,83.841Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pomettes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pomettes-2",
    "data-name": "Pomettes",
    className: "cls-15",
    d: "M101.19264,90.07713c.08178,2.24958-3.69044,4.70349-7.12695,4.45435-1.51781-.11006-4.05306-.82584-4.45434-2.44989-.48937-1.98064,2.39459-4.50448,5.12249-5.1225.27176-.06155,3.66929-.7794,5.56793,1.33631A2.87826,2.87826,0,0,1,101.19264,90.07713Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M68.67593,86.06823a3.78,3.78,0,0,1-3.118.44543,4.68559,4.68559,0,0,1-2.6726-1.78174A19.83283,19.83283,0,0,1,64.667,77.15954,5.99805,5.99805,0,0,1,69.12137,80.723C69.69812,82.09684,70.21255,84.82773,68.67593,86.06823Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Yeux"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M74.06765,70.1086c-.704-.44182-1.69431.05206-2.23174.63275-1.3266,1.43342-1.00213,4.5944,0,5.062.823.384,2.34418-.93568,2.78967-2.531C74.89733,72.29928,74.92913,70.64928,74.06765,70.1086Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M97.91936,77.70326a2.59088,2.59088,0,0,0-1.98432,0c-2.08386.87826-2.02209,4.76051-.66143,5.23859.91286.32076,2.68676-.79385,3.30718-2.09544C99.06541,79.82965,99.06169,78.247,97.91936,77.70326Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Taches_rousseurs",
    "data-name": "Taches rousseurs"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M91.04384,88.32954c-.1591.24273-.682.17194-.98706-.03414-.07949-.05372-.28775-.19445-.28329-.38041a.66875.66875,0,1,1,1.27035.41455Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M68.32669,82.09346c-.1591.24273-.682.17194-.98706-.03414-.07949-.05372-.28775-.19445-.28329-.38041a.66875.66875,0,1,1,1.27035.41455Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M96.093,92.44916a.439.439,0,0,1-.2456.30058.50878.50878,0,0,1-.5581-.40715c-.06465-.32386.25567-.67011.4935-.63781C96.021,91.73707,96.18215,92.14988,96.093,92.44916Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M72.03958,81.3133a.439.439,0,0,1-.24561.30058.50877.50877,0,0,1-.55809-.40715c-.06465-.32386.25566-.67011.4935-.63781C71.96759,80.60122,72.1287,81.014,72.03958,81.3133Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M84.80776,80.31173a.64259.64259,0,0,1-.54163.41128.72475.72475,0,0,1-.72872-.82583.66875.66875,0,1,1,1.27035.41455Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M85.69863,87.88411c-.1591.24273-.682.17193-.98706-.03415-.0795-.05372-.28775-.19444-.28329-.3804a.66875.66875,0,1,1,1.27035.41455Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "bouche"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M70.45767,96.75865c-.32282.30276-.095,1.26616.44544,1.78174a1.80549,1.80549,0,0,0,.89086.44543c2.08167.42869,7.41813,3.398,9.79956,4.89978,2.01854,1.273,2.1412,1.63492,3.118,1.78174,3.00282.45141,5.95078-2.35137,5.79064-2.67261-.07721-.15486-.86514.29177-2.6726.44543a15.61681,15.61681,0,0,1-2.22717,0c-3.8105-.28938-8.43041-3.38915-9.35412-4.00891a26.91658,26.91658,0,0,0-3.118-1.78173C71.06541,96.583,70.6445,96.58346,70.45767,96.75865Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M73.13028,101.213c-.35338.44946.29857,1.53673.44543,1.78174a4.08041,4.08041,0,0,0,1.3363,1.3363c1.35115.87445,4.4562,2.3605,5.34522,1.33631a1.80926,1.80926,0,0,0,0-1.78174c-.29874-.6377-.8489-.97863-3.118-1.78174C73.5488,100.833,73.23,101.0863,73.13028,101.213Z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "t-shirt",
    className: "cls-21",
    d: "M84.18708,133.63029A13.84793,13.84793,0,0,0,90.8686,142.539c5.2096,2.732,10.373.66271,12.02672,0a17.68138,17.68138,0,0,0,9.35412-9.35412c1.91441.81561,4.825,1.97781,8.46325,3.118,6.74845,2.115,8.18829,1.70659,12.02673,3.56347,2.20977,1.069,6.82767,3.303,9.35412,8.01782a16.67512,16.67512,0,0,1,1.78174,8.46325c-.29776,19.7208,4.68793,26.343,1.3363,34.29844C137.65877,208.5732,97.306,210.63159,72.16036,200c-5.06225-2.14028-18.4777-7.81239-20.93542-18.70824-.45435-2.01424-.12859-4.76341.44544-10.245a82.37669,82.37669,0,0,1,4.89978-21.38085c2.5545-6.5509,3.83175-9.82641,6.68151-11.58129,2.4929-1.5352,4.37458-1.27921,14.2539-3.118C80.3619,134.43492,82.68744,133.95142,84.18708,133.63029Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rayures"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rayure"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M145.21711,153.67483a24.60374,24.60374,0,0,1-16.8215,7.127,27.68209,27.68209,0,0,1-2.21335,2.22717c-8.80052,7.903-20.33979,7.9679-29.21628,8.01782-8.58334.04828-16.31214-.028-24.3469-4.89978a33.79808,33.79808,0,0,1-7.52541-6.23608,12.92949,12.92949,0,0,1-5.75472.89087,13.74567,13.74567,0,0,1-8.85342-4.45434,4.10479,4.10479,0,0,0,0,2.22717c1.0307,3.43058,7.01146,4.518,10.6241,4.45434a16.68021,16.68021,0,0,0,3.54137-.44543,34.21367,34.21367,0,0,0,6.19739,5.79064c9.47242,6.84877,19.83833,6.75231,27.4456,6.68152,7.30083-.068,16.439-.273,25.23224-6.23608a34.84917,34.84917,0,0,0,5.75473-4.89978,19.22724,19.22724,0,0,0,8.41074-1.78174,19.42531,19.42531,0,0,0,7.52541-6.23608Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M145.21711,166.147a24.60374,24.60374,0,0,1-16.8215,7.127,30.23412,30.23412,0,0,1-2.21335,2.22717c-9.5231,8.63475-22.02812,8.80864-29.21628,8.90869-8.01552.11147-17.601.2449-26.11759-6.23608a30.03373,30.03373,0,0,1-5.75472-5.79065,12.92949,12.92949,0,0,1-5.75472.89087,13.74567,13.74567,0,0,1-8.85342-4.45434,4.10479,4.10479,0,0,0,0,2.22717c1.0307,3.43058,7.01146,4.518,10.6241,4.45434a16.68021,16.68021,0,0,0,3.54137-.44543,38.00151,38.00151,0,0,0,6.19739,5.79065c13.80553,10.25358,30.37133,7.69961,34.08566,7.12694a46.87241,46.87241,0,0,0,19.47753-7.57238A42.26149,42.26149,0,0,0,129.281,176.392a19.22724,19.22724,0,0,0,8.41074-1.78174,19.42531,19.42531,0,0,0,7.52541-6.23608Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M146.10245,178.61915a24.60369,24.60369,0,0,1-16.82149,7.127,42.14413,42.14413,0,0,1-11.95212,7.57239,44.68824,44.68824,0,0,1-19.47752,3.118,53.8894,53.8894,0,0,1-23.01889-5.79065,51.72649,51.72649,0,0,1-8.85342-5.79065,12.92949,12.92949,0,0,1-5.75472.89087,13.7457,13.7457,0,0,1-8.85342-4.45434,4.10479,4.10479,0,0,0,0,2.22717c1.03071,3.43058,7.01146,4.518,10.62411,4.45434a16.68019,16.68019,0,0,0,3.54136-.44543,47.26939,47.26939,0,0,0,5.75473,4.45434A50.08062,50.08062,0,0,0,99.17933,200c11.89635-.27872,20.45127-4.95752,25.23225-7.57238a62.77959,62.77959,0,0,0,5.75472-3.56348,19.22734,19.22734,0,0,0,8.41074-1.78173,19.42549,19.42549,0,0,0,7.52541-6.23608Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatarLouise);
export default __webpack_public_path__ + "static/media/avatar_louise.48c2a5a32e057836f8a48941a6eb1210.svg";
export { ForwardRef as ReactComponent };